import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { HeatmapActivityResultsImage, HeatmapActivityCommentsTable } from '@visionslive/reporting-components';

const HeatmapTimelineResult = ({ heatmapResults }) => {
    if (!heatmapResults?.stimulusUrl) {
        return null;
    }

    const stimulus = { uri: heatmapResults.stimulusUrl };
    const customSentimentConfig = Object.fromEntries(
        (heatmapResults.sentimentOptions ?? []).map(opt => [opt.sentiment, opt])
    );
    const responses = (heatmapResults.responses ?? []).map((r, i) => ({
        ...r,
        id: i,
        respondentName: r.respondentName ?? ''
    }));

    return (
        <Box sx={{ mt: 1 }}>
            <Box sx={{ display: 'flex', height: 500, overflow: 'hidden' }}>
                <HeatmapActivityResultsImage
                    stimulus={stimulus}
                    responses={responses}
                    customSentimentConfig={customSentimentConfig}
                    annotationType={heatmapResults.annotationType}
                    reportView
                />
            </Box>
            <HeatmapActivityCommentsTable
                responses={responses}
                customSentimentConfig={customSentimentConfig}
                setOnScreenSortBy={() => {}}
                setOnScreenSortOrder={() => {}}
                disablePagination
                hideSessionColumn
            />
        </Box>
    );
};

HeatmapTimelineResult.propTypes = {
    heatmapResults: PropTypes.shape({
        annotationType: PropTypes.string,
        stimulusUrl: PropTypes.string,
        sentimentOptions: PropTypes.array,
        responses: PropTypes.array
    })
};

export default HeatmapTimelineResult;
